module.exports = "<div class=\"phone-input-wrapper\">\r\n  <input\r\n    #phoneInput\r\n    type=\"tel\"\r\n    class=\"form-control\"\r\n    placeholder=\"\"\r\n    autocomplete=\"tel\"\r\n  />\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/phone-input/phone-input.component.html
// module id = ./src/app/shared/phone-input/phone-input.component.html
// module chunks = main